import { FC, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AuthSubHeader from "src/components/authSubHeader";
import FooterText from "src/components/footerText";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import { AuthContext } from "src/context/authContext";
import { getVideoURL } from "src/helpers";




const HubVideoReviewer: FC = (): JSX.Element => {
  const [videoUrl, updateVideoUrl] = useState<{ video: string; poster: string; } | null>(null);

  const { video_name } = useParams()
  const { isManufacturer, isUserAuthorized } = useContext(AuthContext);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (video_name) {
      const userAuth = localStorage.getItem("token")
      updateVideoUrl(getVideoURL(video_name, userAuth && userAuth.length > 0 ? true : false))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
      {isUserAuthorized ?
        <div className="bg-mist py-2">
          <div className="container-fluid">
            {isManufacturer ?
              <AuthMaunfacturerSubHeader /> :
              <AuthSubHeader />
            }
          </div>
        </div>
      : null}
      <div className="container flex-fill d-flex flex-column">
          <video controls className="help-full-videos border m-auto" poster={videoUrl?.poster || ''} src={videoUrl?.video || ''}>
              Your browser does not support the video tag.
          </video>
          <FooterText footerType="black"/>
      </div>
    </div>
  );
}

export default HubVideoReviewer
